import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type { FlowError } from '@ory/client/api';
import type { OryGetInput } from '../../model';
import type { OryRetrievableFlow } from '../flow-capabilities';
import { OryKratosBaseFlow } from './base.flow';

/**
 * Retrieves Ory flow error details for display.
 *
 * Retrieve-only flow. Used when Ory redirects to error page with error ID
 * in query parameters (?id=error-id). Provides error details for user display.
 */
@Injectable({
  providedIn: 'root',
})
export class OryErrorFlow
  extends OryKratosBaseFlow
  implements OryRetrievableFlow<'error'>
{
  get(input: OryGetInput<'error'>): Observable<FlowError> {
    return this.fromOryRequest(this.iamApi.getFlowError(input));
  }
}

